var _defs, _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    width: 29,
    height: 29,
    color: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5e4-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6374f543b67f094e4896c5e4-1",
    cx: 12,
    cy: 12,
    r: 10.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6374f543b67f094e4896c5e4-1",
    x1: 14.86,
    y1: 7.23,
    x2: 14.86,
    y2: 16.77
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6374f543b67f094e4896c5e4-1",
    x1: 9.14,
    y1: 16.77,
    x2: 9.14,
    y2: 7.23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.65470c4975993ce91e58c681b2b066c1.svg";
export { ForwardRef as ReactComponent };